import React from 'react';
import MediaQuery from 'react-responsive'
import './Home2.scss'

const Home2 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    const scroll = () =>{
        return sectionCurrently === Section.Section5 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }

    const mx = "five-body-section fade-in-animation-5 disposition-row justify-around align-center";
    const mt = "five-body-section-t fade-in-animation-5 disposition-column justify-center align-center";
    const mm = "five-body-section-m fade-in-animation-5 disposition-column justify-center align-center";

    return (
        <>
            <MediaQuery minWidth={900}>
                <div className = { `${mx} ${scroll() ? "fade-out-animation-5" : ""}`} id = "section-5">
                    <div className = "five-body-elements disposition-row justify-between align-center">
                        <div className = "description-section disposition-column justify-center align-start">
                            <p className = "title-1">Up to a $100K limit</p>
                            <p className = "text-2">All while building credit score in the US</p>
                            <div className = "disposition-row justify-center align-center">
                                <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                                <p className = "text-1"><b>Credit limits based on analysis of your bank statements</b> from the U.S. We analize your bank movements and underwrite you instantly.</p>
                            </div>
                            <div className = "disposition-row justify-center align-center">
                                <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                                <p className = "text-1"><b>⁠⁠Immediate use </b>on Apple Pay or Google Pay after approval.</p>
                            </div>
                        </div>
                        <img src = "assets/Home/Home2/kartablack-limit-banks.png" className = "banks-img" alt = "Banks"></img>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={900} minWidth={500}>
                <div className = { `${mt} ${scroll() ? "fade-out-animation-5" : ""}`} id = "section-5">
                    <div className = "description-section disposition-column justify-center align-start">
                        <p className = "title-1">Up to a $100K limit</p>
                        <p className = "text-2">All while building credit score in the US</p>
                        <div className = "disposition-row justify-center align-center">
                            <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                            <p className = "text-1"><b>Credit limits based on analysis of your bank statements</b> from the U.S. We analize your bank movements and underwrite you instantly.</p>
                        </div>
                        <div className = "disposition-row justify-center align-center">
                            <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                            <p className = "text-1"><b>⁠⁠Immediate use </b>on Apple Pay or Google Pay after approval.</p>
                        </div>
                    </div>
                    <img src = "assets/Home/Home2/kartablack-limit-banks.png" className = "banks-img" alt = "Banks"></img>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={500}>
                <div className = { `${mm} ${scroll() ? "fade-out-animation-5" : ""}`} id = "section-5">
                    <div className = "description-section disposition-column justify-center align-start">
                        <p className = "title-1">Up to a $100K limit</p>
                        <p className = "text-2">All while building credit score in the US</p>
                        <div className = "disposition-row justify-center align-start" style = {{marginTop: "10px", marginBottom: "20px"}}>
                            <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                            <p className = "text-1"><b>Credit limits based on analysis of your bank statements</b> from the U.S. We analize your bank movements and underwrite you instantly.</p>
                        </div>
                        <div className = "disposition-row justify-center align-start" style = {{marginTop: "0px", marginBottom: "20px"}}>
                            <img src = "assets/Home/Home2/stick.png" className = "icon-img" alt = "icon"></img>
                            <p className = "text-1"><b>⁠⁠Immediate use </b>on Apple Pay or Google Pay after approval.</p>
                        </div>
                    </div>
                    <div className = "disposition-row justify-center align-center">
                        <img src = "assets/Home/Home2/kartablack-limit-banks.png" className = "banks-img" alt = "Banks"></img>
                    </div>
                </div>
            </MediaQuery>
            
        </>
    );
};

export default Home2;
